<template>
  <fts-client-modal
    title="Invitation link settings"
    ref="ftsClientModal"
    @closed="reset"
  >
    <template #body>
      <div class="fts-form-group">
        <fts-form-label placement="top">Expire After</fts-form-label>
        <fts-select
          :options="durations"
          v-model="formData.durationExtend"
          comfort-design
        />
      </div>
    </template>
    <!-- footerRight -->
    <template #footerRight>
      <fts-btn
        text
        text-transform-init
        @click="hide"
      >
        Cancel
      </fts-btn>
      <fts-btn
        color="primary" 
        outline
        textTransformInit
        @click="done"
      >
        Update
      </fts-btn>
    </template>
  </fts-client-modal>
</template>

<script>
import FTSClientModal from '../elements/FTSClientModal'
import FTSBtn from '../elements/FTSBtn'
import FTSFormLabel from '../elements/FTSFormLabel'
import FTSSelect from '../elements/FTSSelect'

export default {
  components: {
    'fts-client-modal': FTSClientModal,
    'fts-btn': FTSBtn,
    'fts-form-label': FTSFormLabel,
    'fts-select': FTSSelect
  },
  data: () => ({
    durations: [
      { 'id': '7', 'name': '7 days' },
      { 'id': '30', 'name': '30 days' },
      { 'id': '0', 'name': 'Never' },
    ],
    formData: null,
    resolve: null,
  }),
  methods: {
    async show(formData) {
      this.formData = _.cloneDeep(formData);
      /* set initial duration */
      this.$set(this.formData, "durationExtend", this.durations[0].id);

      return new Promise(async (resolve) => {
        this.resolve = resolve;
        this.$refs.ftsClientModal.show();
      });
    },
    hide() {
      this.$refs.ftsClientModal.close();
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    done() {
      this.resolve && this.resolve(this.formData);
      this.hide();
    }
  }
}
</script>

<style lang="scss" scoped>
</style>